import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-link-lead',
  templateUrl: './dialog-link-lead.component.html',
  styleUrls: ['./dialog-link-lead.component.scss'],
  standalone: false
})
export class DialogLinkLeadComponent {
  copied = false;
  readonly typeLabel: string;
  readonly dialogTitle: string;
  readonly dialogDescription: string;
  readonly copyButtonLabel: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { url: string; selectedType?: string },
    private dialogRef: MatDialogRef<DialogLinkLeadComponent>
  ) {
    this.typeLabel = this.data.selectedType === 'Project' ? 'project' : 'lead';
    this.dialogTitle = this.data.selectedType === 'Project'
      ? 'Add project info to shared link'
      : 'Add lead info to shared link';
    this.dialogDescription = this.data.selectedType === 'Project'
      ? 'Share the link below to collect project details:'
      : 'Share the link below to collect lead information:';
    this.copyButtonLabel = this.data.selectedType === 'Project'
      ? 'Copy Project Link'
      : 'Copy Lead Link';
  }

  copyUrl() {
    navigator.clipboard.writeText(this.data.url).then(() => {
      this.copied = true;
      setTimeout(() => (this.copied = false), 2000);
    });
  }

  close() {
    this.dialogRef.close();
  }
}
